jQuery(function ($) {

    let pagetop = '#pagetop';

    $(pagetop).hide();
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 300) {
            $(pagetop).fadeIn("slow");
        } else {
            $(pagetop).fadeOut("slow");
        }
        let scrollHeight = $(document).height();
        let scrollPosition = $(window).height() + $(window).scrollTop();
        let footHeight = $("footer").innerHeight();
        if (scrollHeight - scrollPosition <= footHeight) {
            $(pagetop).css({
                "position": "absolute",
                "z-index": "6",
                "bottom": footHeight - 30,
                "right": "1%"
            });
        } else { //それ以外の場合は
            $(pagetop).css({
                "position": "fixed",
                "z-index": "6",
                "bottom": "35px",
                "right": "2%"
            });
        }
    });
    $(pagetop).click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });

  // #で始まるアンカーをクリックした場合にスクロール処理
  $('a[href^="#"]').on('click',function(){
      let speed = 500;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top;
      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
  });
});
